import { Component } from '@angular/core';
import { LoadingController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";
import { EbsWebService } from "../../services/ebsWebService";
import { ViewController } from "ionic-angular";
import { CustomDetail } from '../custom/customdetail/customdetail';

@Component({
  selector: 'page-custom',
  templateUrl: 'custom.html',
  providers: [
    EbsWebService,
    EbsWebServiceGlobals
  ]
})
export class Custom {

      selectedItem:any;
      title: string;
      actionURL: string;
      mainNavigationObjects: any;

      constructor(public viewCtrl: ViewController,
        public navParams: NavParams,
        private _ebsWebService: EbsWebService,
        private _ebsWebServiceGlobals: EbsWebServiceGlobals,
        public loadingCtrl: LoadingController,
        public navCtrl: NavController) {

        this.title = this.navParams.get('title');
        this.actionURL = this.navParams.get('actionURL');

        this.mainNavigationObjects = this._ebsWebService.postData(this.actionURL,null);
          this.mainNavigationObjects.subscribe(res => {
          this.selectedItem = res;
        });
      }

    openDetailPage(actionURLs){
      this.navCtrl.push(CustomDetail, {actionURL: actionURLs});
    }
}



// WEBPACK FOOTER //
// ./src/pages/custom/custom.ts